import { countryAddApi } from "../../api/country/countryAddApi"

type PayloadShape = Parameters<typeof countryAddApi>[0]

export async function countryAddService(payload: PayloadShape, token: string) {
	return await countryAddApi(payload, token)
}
